import React, { useEffect, useMemo } from 'react'
import partition from 'lodash/fp/partition'
import { Link, useLocation } from 'react-router-dom'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { GetReportDetailsQuery, GetReportFavoriteDetailsQuery } from 'gqlTypes'

export function GoToTop() {
  const routePath = useLocation()
  const onTop = () => {
    window.scrollTo(0, 0)
  }
  useEffect(() => {
    onTop()
  }, [routePath])

  return null
}

interface Props {
  report:
    | NonNullable<GetReportDetailsQuery['report']>
    | NonNullable<GetReportFavoriteDetailsQuery['reportWithFavorites']>
  sectionId: string
  favorites?: boolean
}
const ReportPrevNextButtons: React.FC<Props> = ({
  report,
  sectionId,
  favorites = false,
}) => {
  const { prevSection, nextSection } = useMemo(() => {
    const sortedSections = []
    const [rootSections, childSections] = partition(
      (s) => s.parentReportSectionId == null,
      report.sections
    )
    for (const rootSection of rootSections) {
      if (favorites) {
        if (rootSection.hasElementFavorites || rootSection.reportFavorite) {
          sortedSections.push(rootSection)
        }
      } else {
        sortedSections.push(rootSection)
      }
      childSections
        .filter((section) => section.parentReportSectionId === rootSection.id)
        .forEach((section) => sortedSections.push(section))
    }
    const sectionIndex = sortedSections.findIndex(
      (section) => section.id === sectionId
    )

    return {
      prevSection: sortedSections[sectionIndex - 1],
      nextSection: sortedSections[sectionIndex + 1],
    }
  }, [report, sectionId])

  const reportViewPath = favorites ? 'report_bookmarks' : 'reports'

  return (
    <Stack spacing={2} direction="row">
      {prevSection && (
        <Button
          variant="contained"
          color="primary"
          startIcon={<ChevronLeftIcon />}
          component={Link}
          to={`/${reportViewPath}/${report.id}/sections/${prevSection?.id}`}
        >
          PREVIOUS
        </Button>
      )}
      {nextSection && (
        <Button
          variant="contained"
          color="primary"
          endIcon={<ChevronRightIcon />}
          component={Link}
          to={`/${reportViewPath}/${report.id}/sections/${nextSection?.id}`}
        >
          NEXT
        </Button>
      )}
      <GoToTop />
    </Stack>
  )
}

export default ReportPrevNextButtons
